import { compose, withHandlers } from 'recompose'
import reduxForm from 'components/common/hoc/withFormErrorFocus'
import validate from 'components/AppointmentConfirmationPage/AppointmentInfo/validate'
import { APPOINTMENT_FORM_NAME } from 'constant'
import ContactInfo from './ContactInfo'

const withStepHandlers = withHandlers({
  onSubmit: ({ nextPageClick, submitAppointmentContactDetails }) => (values) =>
    submitAppointmentContactDetails(values, nextPageClick),
  onPreviousStep: ({
    onPrevPage,
    beforeNavigatingToDateTimeStep
  }) => () => {
    beforeNavigatingToDateTimeStep()
    onPrevPage()
  }
})

export default compose(
  withStepHandlers,
  reduxForm({
    validate,
    form: APPOINTMENT_FORM_NAME,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })
)(ContactInfo)
